import { DynamicCodeLoader } from '../../utils/DynamicCodeLoader';

class CreditInfoModuleClass {
    public open(){
        this.getSource().then(({CreditInfoManager}) => {
            CreditInfoManager.open();
        });
    }
    
    private sourcePromise: Promise<typeof import('./CreditInfoManager')>;
    private getSource(){
        if(!this.sourcePromise) {
            this.sourcePromise = DynamicCodeLoader.importWebpackModuleWithRetry<typeof import('./CreditInfoManager')>(this.constructSourcePromise);
        }
        
        return this.sourcePromise;
    }

    private constructSourcePromise(){
        return import(/* webpackChunkName: "creditInfo" */'./CreditInfoManager');
    }
}

export const CreditInfoModule = new CreditInfoModuleClass();